// src/api/axiosConfig.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  withCredentials: true,
});

export default api;

